import * as types from '@/store/types'

export default {
  mounted () {
    this.$service.getSetting()
      .then(face => {
        this.$service.updateGuiSetting(face)
      })
      .finally(() => {
        this.$store.dispatch(types.GUI.tryInit.set)
        this.$pageManager.showTableQueue()
      })
  }
}
